import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { RequireAuth as RbacRequireAuth } from '@dreamtree-org/tenancy/react';
import { useAuth } from './useCan';

/** Gate all protected routes: redirect to /login when not authenticated. */
export default function RequireAuth() {
  const user = useAuth();
  const loc = useLocation();
  // A company administrator without two-step can use nothing else yet (server: STRONG_FACTOR_REQUIRED).
  if (user?.needsStrongFactor && loc.pathname !== '/account/security') return <Navigate to="/account/security" replace />;
  return (
    <RbacRequireAuth redirectTo="/login" Navigate={Navigate} state={{ from: loc.pathname }}>
      <Outlet />
    </RbacRequireAuth>
  );
}
